<template>
  <div>
    <div class="header profile" />
    <div class="container">
      <div class="box is-large">
        <h1 class="title is-1">
          Password reset
        </h1>

        <div
          v-if="success"
          class="message is-success has-text-left"
        >
          <div class="message-body">
            You password has been set. You can now log in with your new password.
          </div>
        </div>

        <form
          v-else
          class="form"
          @submit.prevent="submit"
        >
          <div
            v-for="(err, i) in formErrors.non_field_errors"
            :key="i"
            class="message is-danger has-text-left"
          >
            <div class="message-body">
              {{ err }}
            </div>
          </div>

          <div class="field">
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <label class="label">New password</label>
                  <input
                    id="id_password"
                    v-model.trim="password"
                    :class="errorClass('password')"
                    type="password"
                    name="password"
                    class="input"
                    required
                  >
                </div>
                <p
                  v-for="(err, i) in getErrors('password')"
                  :key="i"
                  class="help is-danger has-text-left"
                >
                  {{ err|capitalize }}
                </p>
              </div>
              <div class="field">
                <div class="control">
                  <label class="label">Confirm password</label>
                  <input
                    id="id_confirm_password"
                    v-model.trim="confirmPassword"
                    :class="errorClass('confirmPassword')"
                    type="password"
                    name="confirm_password"
                    class="input"
                    required
                  >
                </div>
                <p
                  v-for="(err, i) in getErrors('confirmPassword')"
                  :key="i"
                  class="help is-danger has-text-left"
                >
                  {{ err|capitalize }}
                </p>
              </div>
            </div>
            <!-- /.field-body -->
          </div>
          <br>
          <button
            type="submit"
            class="button is-block is-primary is-large"
          >
            Reset
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PasswordResetConfirm',

  props: {
    token: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      formErrors: {
        non_field_errors: []
      },
      password: '',
      confirmPassword: '',
      success: false
    }
  },

  methods: {
    submit () {
      this.formErrors = {
        non_field_errors: []
      }

      if (this.password !== this.confirmPassword) {
        this.formErrors.non_field_errors = ['Passwords must match.']
        return
      }

      const payload = {
        token: this.token,
        password: this.password
      }
      this.$store.dispatch('auth/passwordResetConfirm', payload)
        .then(() => {
          this.success = true
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.$set(this, 'formErrors', error.response.data)
            return
          }
          return Promise.reject(error.response)
        })
    },

    getErrors (path) {
      const parts = path.split('.')
      return parts.reduce((p, c) => (p && p[c]) || null, this.formErrors)
    },

    isValid (path) {
      return this.getErrors(path) === null
    },

    errorClass (path) {
      return !this.isValid(path) ? 'is-danger' : ''
    }
  },

  metaInfo: {
    title: 'Password reset'
  }
}
</script>

<style>

</style>
